$(document).ready(function () {
    $('.hero-background-carousel').slick({
        autoplay: true,
        arrows: true,
        mobileFirst: true,
        responsive: [{
            breakpoint: 468,
            settings: {
                arrows: true,
            }
        }]
    });
//     $('.company-logo-wrapper').slick({
//         dots: false,
//         arrows: false,
//         loop: false,
//         speed: 300,
//         slidesToShow: 5,
//         responsive: [
//             {
//                 breakpoint: 1024,
//                 settings: {
//                     slidesToShow: 2,
//                     slidesToScroll: 1,
//                     dots: true,
//                     loop: true,
//                     // autoplay: true,
//                 }
//             },
//             {
//                 breakpoint: 768,
//                 settings: {
//                     slidesToShow: 1,
//                     slidesToScroll: 1,
//                     dots: true,
//                     loop: true,
//                     // autoplay: true,
//                 }
//             }
//         ]
//     })
    $('.blog-section-wrapper').slick({
        dots: false,
        arrows: false,
        loop: false,
        speed: 300,
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true,
                    loop: true,
                    // autoplay: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    loop: true,
                    // autoplay: true,
                }
            }
        ]
    })
    $('.service-card-wrapper').slick({
        dots: false,
        arrows: false,
        loop: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    loop: true,
                    autoplay: true,
                }
            }
        ]
    })
    $('.icon-text-listing-wrapper').slick({
        dots: false,
        arrows: false,
        loop: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    loop: true,
                    autoplay: true,
                }
            }
        ]
    })
    $('.testimonial-cards').slick({
        rows: 2,
        slidesPerRow: 2,
        dots: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    rows: 1,
                    slidesPerRow: 1,
                    dots: true,
                }
            }
        ]
    })
    $('.product-slider').slick({
        mobileFirst: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        rows: 1,
        fade: true,
        swipeToSlide: true,
        infinite: false,
        focusOnSelect: true,
        pauseOnHover:false,
        arrows: false,
        asNavFor: '.product-slider-nav',
        cssEase:'linear',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    arrows: true,
                }
            },
        ]
    });
    $('.product-slider-nav').slick({
        speed:700,
        mobileFirst: true,
        slidesToScroll: 1,
        slidesToShow: 4,
        rows: 1,
        swipeToSlide: true,
        infinite: false,
        focusOnSelect: true,
        pauseOnHover:false,
        dots: true,
        arrows: false,
        asNavFor: '.product-slider',
        cssEase:'linear',
    });
});
$( document ).ready(function() {
    let hamburger = $(".hamburger");
    hamburger.on("click", function(e) {
        hamburger.toggleClass("is-active");
    });
});